import React from 'react';
import styles from './layout.module.css';

const Layout=(props)=>{
	return (
		<React.Fragment>
			<div className={styles.container}>
				<div className={styles.left}> 
					<div className={styles['content-left']}>
						{props.children[0+props.increment]
							?React.cloneElement(props.children[0+props.increment],{feature:true,layout_styles:{
								header_image:styles.header_image,
								title:styles.title,
								author:styles.author,
								description:styles.description,
								content_container:styles.article_content_container
							}})
							:null}
					</div>
				</div>
				<div className={styles.right}>
					<div className={styles['content-top-right']}>
						{props.children[2+props.increment]
							?React.cloneElement(props.children[2+props.increment],{image_type:'CLOSE',layout_styles:{
								title:styles.title,
								title_container:
								styles.title_container,
								description:styles.description,
								container:styles.article_container,
								author:styles.author
							}})
							:null}
					</div>
					<div className={styles['content-bottom-right']}>
						{props.children[1+props.increment]
							?React.cloneElement(props.children[1+props.increment],{image_type:'SQUARE',layout_styles:{
								title:styles.title,
								title_container:
								styles.title_container,
								description:styles.description,
								container:styles.article_container,
								author:styles.author
							}})
							:null}
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export default Layout;